
import React from 'react';
import { Box, Text } from 'grommet';
import { Spinning } from 'grommet-controls';

import ClearLink from './ClearLink';
import InfoPanelTrat from './InfoPanelTrat';

const ADDITIONAL_PANELS = {
    'over_trate': {
        component: InfoPanelTrat
    }
};

const AttributeRow = ({title, value}) => {
    return (
        <Box direction="row">
            <Text size="small" color="dark-4">{title}:</Text>
            <Text size="small" margin={{left: '4px'}}>{value}</Text>
        </Box>
    );
}

const FoundObject = ({object, attributes, layerId}) => {
    const additionalPanel = (ADDITIONAL_PANELS[layerId])
        ? ADDITIONAL_PANELS[layerId].component
        : null;

    return (
        <Box pad={{bottom: '8px'}}>
            {attributes.map(item => {
                return (object[item[0]] && item[1])
                    ? <AttributeRow key={item[0]} title={item[1]} value={object[item[0]]} />
                    : null;
            })}
            {(additionalPanel)
                ? React.createElement(additionalPanel, {object: object})
                : null
            }
        </Box>
    )
}

const FoundObjectType = ({objectType}) => {
    return (
        <Box pad={{left: '12px', right: '12px', bottom: '8px'}}>
            <Box background="dark-3" pad={{left: '4px'}} margin={{bottom: '4px'}}>
                <Text size="medium">{objectType.title}</Text>
            </Box>
            {objectType.objects.map((item, index) => {
                return (
                    <FoundObject
                        key={index}
                        object={item}
                        attributes={objectType.attributes}
                        layerId={objectType.layerId}
                    />
                );
            })}
        </Box>
    );
}

const FoundObjectTypes = ({objectTypes}) => {
    if (objectTypes && objectTypes.data) {
        return (objectTypes.data.length > 0)
            ? objectTypes.data.map(item => {
                return (
                    <FoundObjectType
                        key={item.layerId}
                        objectType={item}
                    />
                );
            })
            : <Text margin={{left: '12px'}} color="dark-4">Nic nenalezeno</Text>
    } else {
        return null;
    }
}

const FindingObjects = () => {
    return (
        <Box direction="row" pad={{left: '12px'}}>
            <Box pad={{right: '12px'}}>
                <Spinning kind='cube-grid' />
            </Box>
            <Text color="dark-4">Vyhledávám objekty v mapě...</Text>
        </Box>
    );
}

const ClearPanel = ({clear, foundObjects, points}) => {
    return ((foundObjects && foundObjects.data) || (points.length > 0))
        ? <ClearLink clear={clear} />
        : null;
}

const InfoPanel = ({clear, foundObjects, points}) => {
    return (
        <Box height="100%">
            <ClearPanel
                clear={clear}
                foundObjects={foundObjects}
                points={points}
            />
            {(foundObjects && foundObjects.loading)
                ? <FindingObjects />
                : (
                    <FoundObjectTypes
                        objectTypes={foundObjects}
                    />
                )
            }
        </Box>
    );
}

export default InfoPanel;
